import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";

import { Layout } from "@/components/Layout";
import Home from "@/pages/Home";
import LeLycee from "@/pages/LeLycee";
import Formations from "@/pages/Formations";
import FormationDetail from "@/pages/FormationDetail";
import Accompagnement from "@/pages/Accompagnement";
import Internat from "@/pages/Internat";
import { Actualites, ActualiteDetail } from "@/pages/Actualites";
import Contact from "@/pages/Contact";
import Telechargements from "@/pages/Telechargements";
import VieAuLycee from "@/pages/VieAuLycee";
import InfosPratiques from "@/pages/InfosPratiques";
import Inclusion from "@/pages/Inclusion";
import Erasmus from "@/pages/Erasmus";
import Orientation from "@/pages/Orientation";
import PrepaMetiers from "@/pages/PrepaMetiers";
import Alternance from "@/pages/Alternance";
import ParentsEleves from "@/pages/ParentsEleves";
import Dispositifs from "@/pages/Dispositifs";
import EspaceEntreprises from "@/pages/entreprises/EspaceEntreprises";
import BureauEntreprises from "@/pages/entreprises/BureauEntreprises";
import TaxeApprentissage from "@/pages/entreprises/TaxeApprentissage";
import DevenirPartenaire from "@/pages/entreprises/DevenirPartenaire";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<Home />} />
            <Route path="/le-lycee" element={<LeLycee />} />
            <Route path="/formations" element={<Formations />} />
            <Route path="/formations/:slug" element={<FormationDetail />} />
            <Route path="/prepa-metiers" element={<PrepaMetiers />} />
            <Route path="/alternance" element={<Alternance />} />
            <Route path="/vie-au-lycee" element={<VieAuLycee />} />
            <Route path="/accompagnement" element={<Accompagnement />} />
            <Route path="/orientation" element={<Orientation />} />
            <Route path="/erasmus" element={<Erasmus />} />
            <Route path="/inclusion" element={<Inclusion />} />
            <Route path="/internat" element={<Internat />} />
            <Route path="/parents-eleves" element={<ParentsEleves />} />
            <Route path="/dispositifs" element={<Dispositifs />} />

            {/* Espace entreprises */}
            <Route path="/entreprises" element={<EspaceEntreprises />} />
            <Route path="/entreprises/bureau" element={<BureauEntreprises />} />
            <Route path="/entreprises/taxe-apprentissage" element={<TaxeApprentissage />} />
            <Route path="/entreprises/devenir-partenaire" element={<DevenirPartenaire />} />
            <Route path="/partenaires" element={<Navigate to="/entreprises" replace />} />

            <Route path="/actualites" element={<Actualites />} />
            <Route path="/actualites/:slug" element={<ActualiteDetail />} />
            <Route path="/infos-pratiques" element={<InfosPratiques />} />
            <Route path="/telechargements" element={<Telechargements />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="*" element={<Home />} />
          </Route>
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </div>
  );
}

export default App;
